import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  const splide01Elements = document.querySelectorAll(".splide01");
  if (splide01Elements.length > 0) {
    splide01Elements.forEach((element) => {
      new Splide(element, {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        interval: 3000,
        pauseOnHover: false,
        arrows: true,
        pagination: false,
        focus: 0,
        gap: "40px",
        fixedWidth: "360px",
        // スマホ
        breakpoints: {
          768: {
            fixedWidth: "320px",
            gap: "16px",
            focus: "center",
            perPage: 1,
          },
        },
      }).mount();
    });
  }
  const splide02Elements = document.querySelectorAll(".splide02");
  if (splide02Elements.length > 0) {
    splide02Elements.forEach((element) => {
      new Splide(element, {
        perPage: 3,
        type: "loop",
        focus: 0,
        autoScroll: {
          speed: 2,
        },
      }).mount({ AutoScroll });
    });
  }
}
